export const ADD_SUCCESS = 'Новый автомобиль добавлен';
export const ADD_ERROR = 'Не удалось добавить новый автомобиль';
